import * as types from './mutations-types'

export default {
    [types.SET_LISTING] (state, payload) {
        state.listing = payload
    },
    [types.DEL_LISTING] (state, accessLocation) {
      var index = state.listing.indexOf(accessLocation);      
      state.listing.splice(index, 1);
    }
}